import React from 'react'
import { connect } from 'react-redux'
import { fetchNotificationCount } from '../../actions/NotificationAction';

import Notification from '../../components/notification/NotificationRoot'

class PushNotification extends React.Component {

  componentDidMount() {
    this.props.dispatch(fetchNotificationCount());
  }

  render(){

    return <Notification
      pushNotificationUrl={'https://'+__API_HOST__+__PUSH_NOTIFICATION_URL__}
      fcmUrl={'https://'+__API_HOST__+__FCM_TEST_URL__}
      isDev={(typeof __IS_DEV__ == 'undefined')?'0':__IS_DEV__}
      notificationCount={this.props.notificationCount}
    />;
  }

}

// PushNotification.propType = {
//   notifications: PropTypes.array.isRequired,
//   isFetching: PropTypes.bool.isRequired
// }

const mapStateToProps = (state) => {
  return {
    notificationCount: state.notification.count,
    isFetching: state.notification.isFetching
  }
}

export default connect(mapStateToProps)(PushNotification);



// WEBPACK FOOTER //
// ./src/pages/notification/Notification.js